<template>
  <div class="contact-me">
    <p class="baseline">Mon profil vous intéresse ?</p>
    <router-link to="/contact">
      <p class="contact-btn">Me contacter</p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ContactMe'
};
</script>

<style lang="scss" scoped>
.contact-me {
  background: var(--grey);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0 100px;
  width: 100vw;
  margin: 45px auto 0 !important;

  a {
    text-decoration: none;
  }

  .contact-btn {
    margin: 0;
    padding: 5px 10px;
    border-radius: 3px;
    border: 1px solid var(--orange);
    color: var(--black);
    background-color: transparent;
    transition: all 0.6 ease-in-out;
  }

  .contact-btn:hover {
    background-color: var(--orange);
  }

  .baseline {
    color: var(--black);
    text-transform: uppercase;
    margin: 10px;
  }
}

@media screen and (min-width: 1024px) {
  .contact-me {
    .baseline {
      font-size: 25px;
    }
    .contact-btn {
      font-size: 20px;
    }
  }
}
</style>
